import { render, staticRenderFns } from "./UserEventRecordPopup.vue?vue&type=template&id=052bd6a6&scoped=true"
import script from "./UserEventRecordPopup.vue?vue&type=script&lang=js"
export * from "./UserEventRecordPopup.vue?vue&type=script&lang=js"
import style0 from "./UserEventRecordPopup.vue?vue&type=style&index=0&id=052bd6a6&prod&lang=css"
import style1 from "./UserEventRecordPopup.vue?vue&type=style&index=1&id=052bd6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bd6a6",
  null
  
)

export default component.exports